const cNames = (...listOfClasses: Array<string|boolean|null>): string => listOfClasses.filter((c: string|boolean|null) => (typeof c === 'string')).join(' ');

export default cNames;
